export function debounce<ArgType extends unknown[]>(fn: (...args: ArgType) => void, delay: number) {
	let timeoutID: number | undefined;
	return (...args: ArgType) => {
		clearTimeout(timeoutID);
		timeoutID = window.setTimeout(function () {
			fn(...args);
		}, delay);
	};
}
